import { render, staticRenderFns } from "./CompetitionStats.vue?vue&type=template&id=7a4e1810&scoped=true"
import script from "./CompetitionStats.vue?vue&type=script&lang=js"
export * from "./CompetitionStats.vue?vue&type=script&lang=js"
import style0 from "./CompetitionStats.vue?vue&type=style&index=0&id=7a4e1810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e1810",
  null
  
)

export default component.exports